import React from "react";

export function Thead(){
  return (
    <thead>
      <tr className="container-table-head">
        <th>SIGUE NAVEGANDO</th><th>LINK WEBS</th>
      </tr>
    </thead>
  );
}
